<template>
  <div class="classroom-box">
    <div class="gift-banner" @click="loadPage('gift')">
      <img :src="require('@/assets/images/gift_banner.jpg')">
    </div>
    <div class="subjects-box">
      <!-- 拼团中的课程 -->
      <ul class="pinking-subjects" v-if="pinkingJoinedPinks && pinkingJoinedPinks.length > 0">
        <li class="pinking_course_item course_item" v-for="(joinPink, index) in pinkingJoinedPinks" :key="index">
          <div class="payed_course_poster">
            <img :src="joinPink.subject.smallLogoImg">
          </div>
          <div class="payed_course_poster_tag">
            <img :src="require('@/assets/icons/play.png')">
          </div>
          <div class="payed_course_info">
            <div class="payed_course_title">
              <p class="payed_course_name">{{ joinPink.subject.title }}</p>
              <img class="corner_icon_update" :src="require('@/assets/icons/corner_icon_update.png')">
            </div>
            <div class="lengthProgress">
              <div class="progress_txt">拼团剩余时间</div>
              <div class="status">
                <van-count-down :time="joinPink.countDownSecond * 1000" @finish="joinPinks.splice(index, 1)" />
              </div>
            </div>
            <button class="payed_course_btn btn_start" @click="toInvite(joinPink.id)">邀请拼团</button>
          </div>
        </li>
      </ul>

      <!-- 学习中的课程 -->
      <ul class="lerning-subjects" v-if="userSubjects && userSubjects.length > 0">
        <li class="payed_course_item course_item" @click="navJudge(userSubject)" v-for="(userSubject, index) in userSubjects" :key="index">
          <div class="payed_course_poster">
            <img :src="userSubject.subject.smallLogoImg">
          </div>
          <div class="payed_course_poster_tag">
            <img :src="require('@/assets/icons/play.png')">
          </div>
          <div class="payed_course_info">
            <div class="payed_course_title">
              <p class="payed_course_name">{{ userSubject.subject.title }}</p>
              <img v-if="userSubject.isFullPurchase" class="corner_icon_update" :src="require('@/assets/icons/corner_icon_update.png')">
              <img v-else class="corner_icon_update" :src="require('@/assets/images/corner_icon_try.png')">
            </div>
            <div class="lengthProgress">
              <div class="progress_txt">已学 {{ userSubject.progress || 0 }} %</div>
              <div class="progress_bar">
                <div class="progress_bar_inner" :style="{ width: (userSubject.progress || 0) + '%' }"></div>
              </div>
            </div>
            <!-- <button class="tv_watch_btn invite_course_id_60" data-courseid="60" style="display: inline-block;">电视看课</button> -->
            <button class="payed_course_btn btn_start">{{ showbtnStartContent(userSubject) }}</button>
          </div>
        </li>
      </ul>
    </div>

    <Tabbar v-if="user && !isSingle" :isDistributor="user.isDistributor" />
    <Subscribe :isSubscribe="user.subscribe" />
    <ActiveSubscribe :isShow="isShowActiveSubscribe" :onClose="closeActiveSubscribe" />
  </div>
</template>
<script>
import Tabbar from '@/components/Tabbar'
// import Course from '@/components/Course'
import Subscribe from '@/components/Subscribe'
import ActiveSubscribe from '@/components/ActiveSubscribe'
import { getMyClassroomData } from './query.gql'
export default {
  name: 'classroom',
  data() {
    return {
      user: '',
      isShowActiveSubscribe: false,
      joinPinks: [], // 我参与的团
      userSubjects: [], // 我的课程
      units: [], // 课程栏目
      isSingle: false
    }
  },
  components: {
    // Course,
    Tabbar,
    Subscribe,
    ActiveSubscribe
  },
  computed: {
    pinkingJoinedPinks() {
      // 我参与的拼团正在拼团中且截止时间大于当前时间, 才显示此拼团信息
      return this.joinPinks.filter(jp => ['open', 'ongoing'].includes(jp.status) && jp.countDownSecond > 0)
    }
  },
  async mounted() {
    await this.weixinAuth('snsapi_userinfo')
    const self = this
    self.$toast.loading({
      mask: true,
      duration: 0,
      message: '加载中'
    })
    self.$apollo.query({
      query: getMyClassroomData,
      fetchPolicy: 'no-cache'
    }).then(res => {
      self.user = res.data.profile
      self.joinPinks = res.data.joinPinks
      self.userSubjects = res.data.userSubjects
      self.units = res.data.units
      self.$toast.clear()
    }).catch(err => {
      console.error('page: classroom/index。请求getMyClassroomData报错', err)
      self.$toast.fail('加载数据出错')
    })

    this.isSingle = this.$route.query.isSingle
  },
  methods: {
    toInvite(id) {
      this.$router.push({
        name: 'groupInvite',
        params: { id }
      })
    },
    showbtnStartContent(userSubject) {
      let content = ''
      if (userSubject.getSource === 'send' && !this.user.subscribe) {
        content = '未激活'
      } else {
        content = userSubject.progress > 0 ? '继续学习' : '开始学习'
      }
      return content
    },
    navJudge(userSubject) {
      if (userSubject.getSource === 'send' && !this.user.subscribe) {
        this.isShowActiveSubscribe = true
      } else {
        this.loadPage('learn', { id: userSubject.subject.id })
      }
    },
    closeActiveSubscribe() {
      this.isShowActiveSubscribe = false
    }
  }
}
</script>
<style lang="scss">
.classroom-box {
  background-color: #F6F6F6;
  // img {
  //   display: inline-block;
  //   width: 100%;
  //   vertical-align: bottom;
  //   pointer-events: none;
  // }
  .gift-banner {
    width: 100%;
    margin-bottom: 20px;
    img {
      width: 100%;
    }
  }
  .subjects-box {
    .pinking-subjects, .lerning-subjects {
      margin-bottom: 1rem;
      .course_item {
        position: relative;
        display: flex;
        justify-content: space-between;
        padding: 17.76px 0 0;
        width: 100%;
        height: 103.672px;
        font-size: 0;
        background-color: #fff;
        & > div {
          display: inline-block;
          width: 50%;
          height: 100%;
          vertical-align: top;
        }
        .payed_course_poster {
          padding-left: 15.36px;
          position: relative;
          width: 102.719px;
          & > img {
            width: 102.719px;
            height: 102.719px;
            border-radius: 9.6px;
          }
        }
        .payed_course_poster_tag {
          position: relative;
          width: 17.2656px;
          height: 103.672px;
          margin-top: 38.4px;
          margin-left: -12px;
          & > img {
            position: relative;
            width: 17.2656px;
            height: 17.2656px;
            margin-top: 38.4px;
            margin-left: -12px;
          }
        }
        .payed_course_info {
          margin-right: 15.36px;
          width: 60%;
          box-sizing: border-box;
          position: relative;
          .payed_course_title {
            display: flex;
            .payed_course_name {
              margin-bottom: 10.56px;
              font-size: 15.36px;
              font-weight: bold;
              color: #4c4c4c;
              margin-top: 7.2px;
            }
            .corner_icon_update {
                // position: absolute;
                // left: .32rem;
                margin-top: -1.44px;
                margin-left: 11.04px;
                width: 31.6719px;
                height: 31.6719px;
            }
          }
          .lengthProgress {
            display: flex;
            .progress_txt {
              font-size: 12.48px;
              color: #9b9b9b;
            }
            .progress_bar {
              margin: 0.96px 0 0 9.6px;
              width: 108.469px;
              height: 7.67188px;
              border-radius: 3.84px;
              overflow: hidden;
              background-color: #fff;
              border: 1px solid #ffa67f;
              .progress_bar_inner {
                width: 0%;
                height: 100%;
                background-color: #ffa67f;
              }
            }
          }
          .tv_watch_btn {
            display: inline-block;
            position: absolute;
            bottom: 9.6px;
            right: 94.08px;
            height: 28.7969px;
            padding: 0 9.6px;
            line-height: 28.8px;
            text-align: center;
            font-size: 12.48px;
            border-radius: 13.44px;
            color: #fff;
            background: #ff4800;
            border: unset;
          }
          .payed_course_btn {
            background-color: #ff4800;
            min-width: 67.2px;
            position: absolute;
            bottom: 9.6px;
            right: 0;
            height: 28.7969px;
            padding: 0 9.6px;
            line-height: 28.8px;
            text-align: center;
            font-size: 12.48px;
            border-radius: 13.44px;
            color: #fff;
            border: unset;
          }
        }
      }
    }

    .pinking-subjects {
      .lengthProgress {
        .progress_txt {
          line-height: 18px;
        }
        .status {
          color: #9b9b9b;
          display: flex;
          .van-count-down {
            padding-left: 10px;
            color: #ff4800;
          }
        }
      }
      .btn_start {
        background-color: rgb(64, 119, 236) !important;
      }
    }
  }
  .recommend-subjects {
    padding: 16.56px;
  }
}
</style>
